/*
 * The applicant pages (Hiring v2, 2026-11-04): what the careers page and the call time page get. Its own file because it
 * uses the client pages' brand shape (billing.zod.ts), which website.zod.ts cannot import without a loop.
 */
import { z } from "zod";
import { publicBrand } from "./billing.zod.js";
import { APPLY_LANGS } from "./hiring.js";

/** What the careers page shows: the brand and the roles they can pick. */
export const careersPage = z.object({
  brand: publicBrand,
  roles: z.array(z.object({ id: z.string(), name: z.string(), nameEs: z.string() })),
});
export type CareersPage = z.infer<typeof careersPage>;

/** The page an applicant opens from our text to pick or change their phone screen time (/a/<token>). */
export const applyBooking = z.object({
  brand: careersPage.shape.brand,
  first: z.string(),
  language: z.enum(APPLY_LANGS),
  /** Open times, as instants. */
  slots: z.array(z.string()),
  /** Their booked time, or null. */
  booked: z.string().nullable(),
  minutes: z.number(),
  /** Off the board or hired: nothing to pick. */
  closed: z.boolean(),
  timezone: z.string(),
});
export type ApplyBooking = z.infer<typeof applyBooking>;
export const applyBookInput = z.object({ at: z.iso.datetime() }).strict();
